import { render, staticRenderFns } from "./PersonClientSelect.vue?vue&type=template&id=f2e1a704&scoped=true&"
import script from "./PersonClientSelect.vue?vue&type=script&lang=js&"
export * from "./PersonClientSelect.vue?vue&type=script&lang=js&"
import style0 from "./PersonClientSelect.vue?vue&type=style&index=0&id=f2e1a704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e1a704",
  null
  
)

export default component.exports